module.exports = __webpack_public_path__ + "static/media/auth-register-illustration-light.eaee8454.png";